'use client';

import { initializeClientContext } from '@utils/client-context';
import { useEffect } from 'react';

export function ClientContextBootstrap() {
  useEffect(() => {
    const initialize = () => {
      initializeClientContext().catch((error) => {
        console.error('Failed to initialize client context:', error);
      });
    };

    if ('requestIdleCallback' in window) {
      const idleCallbackId = window.requestIdleCallback(initialize, {
        timeout: 3000,
      });

      return () => window.cancelIdleCallback(idleCallbackId);
    }

    const timeoutId = setTimeout(initialize, 1);
    return () => clearTimeout(timeoutId);
  }, []);

  return null;
}
